module.exports = __webpack_public_path__ + "215f0ebe5b4501294d491db022b5af12.svg";